import { useCallback, useState } from "react";
import { getReturningUser } from "../utils/returningUser.js";
export function useAuthDialog() {
    const [state, setState] = useState({
        isOpen: false,
        screen: 'sign-in'
    });
    const openSignIn = useCallback((options)=>{
        const returning = getReturningUser();
        setState({
            isOpen: true,
            screen: returning ? 'returning-user' : 'sign-in',
            options
        });
    }, []);
    const openSignUp = useCallback((options)=>{
        setState({
            isOpen: true,
            screen: 'sign-up-step1',
            options
        });
    }, []);
    const openToScreen = useCallback((screen, options)=>{
        setState({
            isOpen: true,
            screen,
            options
        });
    }, []);
    const close = useCallback(()=>{
        setState((prev)=>({
                ...prev,
                isOpen: false,
                options: undefined
            }));
    }, []);
    const goToScreen = useCallback((screen, email)=>{
        setState((prev)=>({
                ...prev,
                screen,
                signUpEmail: screen === 'sign-up-step2' ? email : undefined,
                signInEmail: screen === 'sign-in' ? email : undefined
            }));
    }, []);
    return {
        isOpen: state.isOpen,
        screen: state.screen,
        signUpEmail: state.signUpEmail,
        signInEmail: state.signInEmail,
        options: state.options,
        openSignIn,
        openSignUp,
        openToScreen,
        close,
        goToScreen
    };
}

//# sourceMappingURL=useAuthDialog.js.map